let source: any = null;

export function subscribeToProject(isoDate: string, keyCallback: any, updateCallback: any) {
  if ((window as any).EventSource) {
    console.log('Subscribing to project', isoDate);

    // Close existing connections
    if (source) source.close();

    source = new (window as any).EventSource('/api/v1/project/' + isoDate + '/updates');

    // Initial event where we get the update key
    source.addEventListener('key', (e: any) => {
      keyCallback(e.data);
    });

    // Update events
    source.addEventListener('update', updateCallback, false);

    return true;
  } else {
    console.log('Server side events not supported');
    return false;
  }
}
